<template>
    <div style="display: flex; flex-direction: row; flex-wrap: wrap;" class="q-mt-xs q-mb-sm">
        <div v-if="items.length == 0" class="text-caption q-ml-md text--secondary">
            {{ Translate('No items visible - check your filter settings') }}
        </div>
        <div v-for="(metric,j) in items" :key="j" style="width: 320px; max-width: 320px; display: flex; flex-direction: row;" class="q-mr-md q-pl-sm">
            <q-btn
                   flat
                   dense
                   no-caps
                   class="text-weight-regular subtitle-1 q-py-none"
                   style="color: var(--v-primaryText-base);"
                   @click="toggleGroupby(metric)"
                   :disabled="isDisabledSource(metric)">
                <q-icon v-if="isMetricInUse(metric)" class="q-mr-xs" color="primary" name="mdi-checkbox-marked" />
                <q-icon v-else class="q-mr-xs" name="mdi-checkbox-blank-outline" />
                <span class="ellipsis" :style="{ maxWidth: '230px' }">{{ getTitle(metric) }}</span>
            </q-btn>
            <q-btn
                v-if="isMetricInUse(metric) && (metric.SourceType == 'durationColumn' || metric.SourceType == 'countColumn' || metric.SourceType == 'floatColumn')"
                   flat
                   dense
                   no-caps
                   class="text-weight-regular subtitle-1 q-py-none"
            >
                <q-icon color="secondaryText" name="mdi-menu-down" />
                <q-menu
                    v-model="metric.menu_is_open"
                    anchor="bottom left"
                    self="top left"
                    :offset="[0, 8]"
                >
                    <CardHistogram
                        :item="{ ...metric, ...updated_groupbysettings[metric.colId] }"
                        @close="metric.menu_is_open = false"
                        @change="settingschanged"
                    />
                </q-menu>
            </q-btn>

            <q-btn
                v-if="isMetricInUse(metric) && metric.SourceType == 'dateColumn'"
                   flat
                   dense
                   no-caps
                   class="text-weight-regular subtitle-1 q-py-none"
            >
                <q-icon color="secondaryText" name="mdi-menu-down" />
                <q-menu
                    v-model="metric.menu_is_open"
                    anchor="bottom left"
                    self="top left"
                    :offset="[0, 8]"
                >
                    <q-list dense>
                        <q-item
                            v-for="(item, idx) in intervals"
                            :key="item.value"
                            clickable
                            v-ripple
                            dense
                            class="mediumdense"
                            :active="interval_idx === idx"
                            @click="interval_idx = idx"
                        >
                            <q-item-section>
                                <q-item-label>{{ Translate(item.text) }}</q-item-label>
                            </q-item-section>
                        </q-item>
                    </q-list>
                </q-menu>
            </q-btn>
        <q-space />

        <q-btn dense round flat size="sm" class="q-ma-none" @click="showHelp(metric)" style="color:var(--v-checkboxGrey-base)" icon="mdi-information">
            <q-tooltip anchor="bottom middle" self="top middle" :delay="350" transition-show="scale" transition-hide="scale">
                <span style="font-weight: bold; font-size: larger;">{{ metric.Category }} - {{ metric.Title }}</span><br />
                <span style="font-size: larger;">{{ getMetricHelp(metric) }}</span><br />
                <span sstyle="font-style: italic;" v-if="metric.Sources">{{ Translate('Source(s):') }} {{ metric.Sources.join(', ') }}</span>
            </q-tooltip>
        </q-btn>
        </div>
    </div>
</template>

<script>
    import CardHistogram from './cardHistogram.vue';
    import methods from '@/Shared/methods';

    export default {
        components: {
            CardHistogram
        },
        data: function () {
            return {
                metricMenu: [],
                interval_idx: 0,
                updated_groupbysettings:{},
            }
        },
        props: {
            items: null,
            groupbysettings: {},
            isMetricInUse: null,
            showHelp: null,
            isDisabledSource: null,
            toggleGroupby: null,
            getMetricHelp: null,
            metric_types: null,
            interval_choice: null,
            refreshReport: null
        },
        created() {
            this.interval_idx = this.intervals.findIndex(a => a.value == this.interval_choice); // this.interval_selection;
            this.updated_groupbysettings = this.groupbysettings;
        },
        computed: {
            intervals: function () {
                return [
                    { text: this.Translate('15 minutes'), value: '15m' },
                    { text: this.Translate('30 minutes'), value: '30m' },
                    { text: this.Translate('1 hour'), value: '1h' },
                    { text: this.Translate('2 hours'), value: '2h' },
                    { text: this.Translate('3 hours'), value: '3h' },
                    { text: this.Translate('6 hours'), value: '6h' },
                    { text: this.Translate('12 hours'), value: '12h' },
                    { text: this.Translate('1 day'), value: '1d' },
                    { text: this.Translate('2 days'), value: '2d' },
                    { text: this.Translate('3 days'), value: '3d' },
                    { text: this.Translate('1 week'), value: 'week' },
                    { text: this.Translate('1 month'), value: 'month' },
                    { text: this.Translate('1 quarter'), value: 'quarter' },
                    { text: this.Translate('180 days'), value: '180d' },
                    { text: this.Translate('1 year'), value: 'year' },
                    { text: this.Translate('Day of Week'), value: 'dow' },
                    { text: this.Translate('Hour of Day'), value: 'hod' },
                    { text: this.Translate('Half Hour of Day'), value: 'h30od' },
                    { text: this.Translate('Day of Week & Hour of Day'), value: 'dowhod' },
                ];
            },
        },
        watch: {
            interval_idx: function (newv) {
                if (this.interval_idx >= 0 && this.intervals[this.interval_idx])
                    this.$emit('intervalchanged', this.intervals[this.interval_idx].value);
            },
        },
        methods: {
            ...methods,
            getTitle(metric) {
                const settings = this.groupbysettings[metric.colId];
                switch(metric.SourceType) {
                    case 'dateColumn':
                        return metric.Title + (this.interval_idx >= 0 ? ` (${this.intervals[this.interval_idx].text})` : '');
                    case 'durationColumn':
                        if (this.isMetricInUse(metric))
                            return `${metric.Title} (${settings?.interval || metric.interval || 30} ${this.Translate('sec')})`;
                        else
                            return metric.Title;
                    default:
                        return metric.Title;
                }
            },
            settingschanged(item){
                console.log('settingschanged:');
                console.log(JSON.stringify(item,null,3));
                this.updated_groupbysettings[item.colId] = item;
                this.$emit('settingschanged', this.updated_groupbysettings);

            }
        }
    }
</script>

<style scoped>
    .hidden-element {
        visibility: hidden;
    }

    .columns-two {
        column-count: 2;
    }

    .columns-three {
        column-count: 3;
    }

    .verydense {
        max-height: 24px;
        min-height: 24px;
    }

    .mediumdense {
        max-height: 28px;
        min-height: 28px;
    }

    p {
        font-size: 2em;
        text-align: center;
    }

    .metric_normal {
    }

    .metric_inuse {
        color: cornflowerblue;
    }

    .metric_usedup {
        color: silver;
    }
</style>